import { Grid, Button } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { Component, Fragment } from 'react';
import { Animated } from 'react-animated-css';
import { connect } from 'react-redux';
import { Prompt, withRouter } from 'react-router-dom';
import join from 'url-join';
import axios, { safeGet } from '../axios-default';
import Loader from '../components/Loader';
import PercentageProgressRing from '../components/PercentageProgressRing';
import NewPatientDelivery from '../components/NewPatient/Address/NewPatientDelivery';
// import components
import NewPatientInfo from '../components/NewPatient/Info/NewPatientInfo';
import NewPatientsButtonTabs from '../components/NewPatient/NewPatientButtonTabs';
import NewPatientsTabs from '../components/NewPatient/NewPatientsTabs';
import NewPatientSummary from '../components/NewPatient/NewPatientSummary/NewPatientSummary';
import NewPatientPhotos from '../components/NewPatient/Photos/NewPatientPhotos';
import NewPatientPrescriptionNotes from '../components/NewPatient/PrescriptionNotes/NewPatientPrescriptionNotes';
import { ApiServerUrl } from '../config.json';
import * as saveAction from '../store/NewPatient/NewPatient.action';
import { easySnackbar } from '../store/Noti/noti.actions';
import { withLang, getFromObj } from '../util/lang';
import '../util/array';
import { getFormToken } from '../util/file';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import AlertDialog from '../components/Dialog/Dialog';
import { postTraceLog } from '../store/TraceLog/tracelog.reducer';
import { sendLogToServer } from '../../src/util/customLogger';
import Banner from '../components/Banner';
import SmileDesignPrescriptionNotes from './SmileDesign/SmileDesignPrescriptionNotes';
import {
    checkReleaseSmileDesignByDstriAndAllowUserTest,
    smileDesignProductList,
    smileDesignProductListArray,
} from '../store/SmileDesign/SmileDesignSlice';

import { updateLastOpenCaseId } from '../store/NewCase/NewCase.action';
import { useDispatch } from 'react-redux';
import { fetchUserTest } from '../api/userTest';
import DiffRetainerTab from './DiffRetainer/DiffRetainerTab';
import { getRetainerRequestPrescriptionNotesData } from './newPatient_util';
import { setDialog } from '../store/ErrorMessage/ErrorMessageSlice';

import RetainerRequestHandler from './DiffRetainer/modal/RetainerRequestHandler';
import { initRetainerReqFormValue } from '../store/DiffRetainers/reducer';
import { getInitRetainerReq } from './DiffRetainer/utils';
import { openModal } from '../store/Global/global';
import { ERROR, ROLE_NAMES } from '../util/const';
import { fetchConnectPlatformData } from '../store/ConnectPlatform/connectPlatform';
import {
    ALIGNER_CASE_TYPE,
    Base_Prescription_Err,
    Base_Smile_Design_Prescription_Err,
    buildSmileDesignPrescriptionErr,
    CASE_TYPE,
    SELF_DESIGN_CASE_TYPE,
} from '../store/NewPatient/utils';
import { validateFormFieldsOnChangeForTabsReminder } from '../util/alignerPrescriptionFormHelper';
import {
    ALIGNER_WORKFLOW_TABS,
    extractSmileDesignFormDataForUpsell,
    getBaseAlignerWorkFlowTabs,
    getBaseEmptySmileDesignFormData,
    handleCleanUpAddOnSmileDesignSubValue,
    handlePreImplantAligment,
    handleRestorativeOptions,
    handleSetAddOnSmileDesignValue,
    handleSetPreImplantAligmentData,
    handleSetRestorativeOptionsData,
    proccessUpsellSmileDesignDataFromServerToStore,
    RETAINER_WORKFLOW_TABS,
    SELF_DESIGN_WORKFLOW_TABS,
    shouldShowUpsellForm,
    WORKFLOW_TAB,
} from '../components/NewPatient/NewPatientUtill';
import { createStaticSmileDesignQuestionSchema } from './SmileDesign/SmileDesignQuestions';
import UpSellSmileDesignPrescriptionNotes from './SmileDesign/UpSellSmileDesignPrescriptionNotes';
import _ from 'lodash';

const styles = (theme) => ({
    back: {
        margin: '8px',

        background: '#404156',
        color: 'white',
        fontSize: '16px',
        textTransform: 'unset',
        '&:hover': {
            background: '#404156',
        },
    },
    root: {
        margin: '48px auto',
        [theme.breakpoints.down('sm')]: {
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            width: '70%',
            minHeight: '400px',
        },
    },
    mainContainer: {
        textAlign: 'left',
        boxShadow: '0 1px 2px rgba(0,0,0,0.15)',
        backgroundColor: 'white',
        padding: 16,
        [theme.breakpoints.down('xs')]: {
            maxHeight: 'unset',
        },
    },
    devicesContainer: {
        padding: 16,
        background: '#f2f2f2',
        [theme.breakpoints.down('sm')]: {
            padding: 0,
        },
    },
});
const formStartRef = React.createRef();
const PLATFORM = 'systemlog';
const MODULE = 'cases';
const ACTION = 'create case';
const newCaseSamePatientAction = 'newCaseSamePatient';

class NewPatient extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabMode: 'info',
            error: {},
            patientInfo: null,
            countryList: null,
            stateList: null,
            addressList: null,
            saved: false,
            case_impression_id: null,
            uploading: false,
            savingData: false,
            NewCaseType: this.props.match.params.type,
            NewCaseOption: this.props.match.params.caseTypeOption,
            showAlert: false,
            alertMessage: '',
            isSubmit: false,
            threeshapeConnected: false,
            doctor_dist_id: JSON.parse(localStorage.getItem('doctor_dist_id')),
            checkCaseOptionAuth: true,
            checkCaseTypeAuth: true,
            role: JSON.parse(localStorage.getItem('role')),
            traceLogs: [],
            case_type_null_record: [],
            ray_draft_changed: [],
            case_type_id: null,
            pm: {}, //productMatrix
            rayFiles: [],
            isRayCase: 0,
            current_patient_id: this.props.match.params.patientsid ?? null,
            isDraft: true,
            // isNeedToRedirectToNewPatient: false,
            doctor_patient_list: [],
            doctor_patient_CanSubmitSmileDesignCaseList: [],
            doctor_patient_CanSubmitAlignerCaseIfSmileDesignCaseList: [],
            isExcludeDraftWarning: false,
            isMarieGroup: JSON.parse(localStorage.getItem('isMarieGroup')),
            isTWGroup: JSON.parse(localStorage.getItem('isTWGroup')),
            isSEAGroup: JSON.parse(localStorage.getItem('isSEAGroup')),
            tabs: getBaseAlignerWorkFlowTabs(),
            isValidatedOnMount: false,
        };
        this.progressBarRef = React.createRef(null);
        this.handleSave = this.handleSave.bind(this);
        this.scrollToView = this.scrollToView.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.handleAlertClose = this.handleAlertClose.bind(this);
    }

    scrollToView() {
        formStartRef.current.scrollIntoView({ behavior: 'smooth' });
    }

    validatePrescriptionForErrReminder() {
        const {
            attachments1,
            spacingAndCrowding1,
            openbite1,
            deepBite1,
            midline1,
            posteriorCrossbite1,
            auxiliaries1,
            restorativeOptions,
            preImplantAligment,
            archToTreat,
            anteriorPosteriorRelationship1,
        } = this.props.NewPatientData;
        const isShowErrorReminder = validateFormFieldsOnChangeForTabsReminder({
            attachments: attachments1,
            spacingAndCrowding: spacingAndCrowding1,
            openbite: openbite1,
            deepBite: deepBite1,
            midline: midline1,
            posteriorCrossbite: posteriorCrossbite1,
            auxiliaries: auxiliaries1,
            restorativeOptions,
            preImplantAligment,
            archToTreat,
            anteriorPosteriorRelationship: anteriorPosteriorRelationship1,
        });
        return isShowErrorReminder;
    }

    isCaseTypeAligner() {
        const isCaseTypeAligner = ALIGNER_CASE_TYPE.includes(this.state.NewCaseType);
        return isCaseTypeAligner;
    }

    isCaseTypeSelfDesign() {
        return SELF_DESIGN_CASE_TYPE.includes(this.state.NewCaseType);
    }

    isTabsReady() {
        if (this.isCaseTypeAligner()) {
            return this.state.isValidatedOnMount;
        }
        return true;
    }

    getErrorBubbleForTab(tab) {
        const { upSellSmileDesignPrescriptionFormIsValid } = this.props.NewPatientData;
        let err = {
            id: '',
            msg: '',
            valid: true,
        };
        let isShowErrorReminder = false;
        switch (tab) {
            case WORKFLOW_TAB.PRESCRIPTION_NOTES:
                isShowErrorReminder = this.validatePrescriptionForErrReminder();
                if (isShowErrorReminder) {
                    err.id = Base_Prescription_Err.id;
                    err.msg = isShowErrorReminder ? this.get('@NewPatient.warning.prescription_notes') : '';
                    err.valid = isShowErrorReminder ? false : true;
                } else {
                    err.id = Base_Prescription_Err.id;
                    err.msg = '';
                    err.valid = true;
                }
                break;
            case WORKFLOW_TAB.PRESCRIPTION_NOTES_UPSELL_SMILE_DESIGN:
                isShowErrorReminder = upSellSmileDesignPrescriptionFormIsValid === false;
                if (isShowErrorReminder) {
                    err = buildSmileDesignPrescriptionErr(false, () =>
                        this.get('@NewPatient.warning.smile_design_prescription_notes')
                    );
                }
                break;
            default:
                break;
        }
        return err;
    }

    componentDidUpdate(prevProps, prevState) {
        let { history } = this.props;
        if (prevProps.NewPatientData.saveSuccess && this.props.NewPatientData.saveSuccess) {
            this.props.initData();
            this.props.showSnackbar('Saved', 'success');
            history.push('/');
        }

        const isFromOtherTab = this.state.tabMode !== prevState.tabMode;
        const tabsNeedToScroll = [WORKFLOW_TAB.PHOTOS, WORKFLOW_TAB.PRESCRIPTION_NOTES_UPSELL_SMILE_DESIGN];
        if (tabsNeedToScroll.includes(this.state.tabMode) && formStartRef.current) {
            if (isFromOtherTab) {
                this.scrollToView();
            }
        }

        if (prevProps.NewPatientData !== this.props.NewPatientData && this.isCaseTypeAligner()) {
            const { addOnSmileDesign } = this.props.NewPatientData;
            const isAddOnSmileDesign = addOnSmileDesign?.value === 'Yes';
            let targetTabs = [...getBaseAlignerWorkFlowTabs()];
            if (isAddOnSmileDesign) {
                targetTabs = [...ALIGNER_WORKFLOW_TABS];
            }
            this.setState({ tabs: targetTabs });

            const errors = this.props.NewPatientData.errors || [];
            const prescriptionErr = this.getErrorBubbleForTab(WORKFLOW_TAB.PRESCRIPTION_NOTES);
            let upsellPrescriptionErr = isAddOnSmileDesign
                ? this.getErrorBubbleForTab(WORKFLOW_TAB.PRESCRIPTION_NOTES_UPSELL_SMILE_DESIGN)
                : { ...Base_Smile_Design_Prescription_Err };
            const errObj = {
                [prescriptionErr.id]: prescriptionErr,
                [upsellPrescriptionErr.id]: upsellPrescriptionErr,
            };
            if (Array.isArray(errors)) {
                if (!errors.length) {
                    Object.values(errObj).forEach((e) => {
                        if (!e.valid) {
                            this.props.ErrorData(e);
                        }
                    });
                } else {
                    errors.forEach((e) => {
                        const targetErr = errObj[e.id];
                        if (targetErr) {
                            const isErrUpdated = e.valid !== targetErr.valid;
                            if (isErrUpdated) this.props.ErrorData(targetErr);
                        }
                    });
                }
            }
        }

        if (this.state.isSubmit) {
            this.setState({
                uploading: false,
                savingData: false,
                isSubmit: false,
            });
        }
    }

    handleAlertClose() {
        this.setState({
            showAlert: false,
            alertMessage: '',
            savingData: false,
            uploading: false,
        });
    }

    createTraceLog(stepNumber) {
        const currentDateTime = new Date().toISOString();
        const jsonStructure = {
            page_name: 'NewPatient',
            step: `Step ${stepNumber}`,
            log_time: currentDateTime,
            userId: JSON.parse(localStorage.getItem('auth-token')),
        };
        return jsonStructure;
    }

    async handleSave(saveType) {
        this.addTraceLogToState('save function start');
        try {
            this.setState({
                uploading: true,
            });
            this.setState({
                savingData: true,
            });
            const form = new FormData();
            const formCheckPromotionCode = new FormData();

            let newState = { ...this.props.NewPatientData };
            let newAddress = { ...this.props.NewPatientAddressData };
            let modifiedKey,
                modifiedState = {},
                case_file = {},
                case_impression = {},
                case_detail = {},
                questionnaire_teeth_array,
                radioCounter = 0,
                stlCounter = 0;

            let date_of_birth = newState['day'] + '-' + newState['month'] + '-' + newState['year'];
            let questionnaire_teeth = newState['teeth'];
            let files = newState['files'];

            questionnaire_teeth_array = questionnaire_teeth.map((value, index) => {
                if (value.checked) {
                    return index;
                }
                return null;
            });

            files.forEach((value, index) => {
                if (value.category === 'stl_file') {
                    const fileName = `$$FILE:stl_file${stlCounter}`;
                    case_impression['stl_file' + stlCounter] = {
                        data: getFormToken(form, value.data, fileName),
                        rotate: value.rotate,
                        upload_later: value.upload_later,
                    };
                    // case_impression['stl_file' + stlCounter] = await fileToBase64(value.data)
                    case_impression['stl_files_later'] = value.upload_later
                        ? true
                        : value.will_not_upload
                          ? null
                          : false;
                    // case_impression['type'] = "FILE"
                    stlCounter++;
                } else if (!['CN'].includes(process.env.REACT_APP_ENV) && value.id === 'cbct') {
                    case_file['radio2'] = { data: value.data, rotate: 0 };
                    case_file['radio2_later'] = value.upload_later ? true : value.will_not_upload ? null : false;
                } else if (value.category === 'radio') {
                    const fileName = `$$FILE:radio${radioCounter}`;
                    case_file['radio' + radioCounter] = {
                        data: getFormToken(form, value.data, fileName),
                        rotate: value.rotate,
                    };
                    case_file['radio' + radioCounter + '_later'] = value.upload_later
                        ? true
                        : value.will_not_upload
                          ? null
                          : false;
                    //case_file[value.category+radioCounter] = {data:value.data,rotate:value.rotate,upload_later:value.upload_later}
                    radioCounter++;
                } else {
                    const fileName = `$$FILE:photo${index}`;
                    //case_file[value.category+index] = {data:value.data,flipped:value.flipped,rotate:value.rotate,upload_later:value.upload_later}
                    case_file['photo' + index] = {
                        data: getFormToken(form, value.data, fileName),
                        flipped: value.flipped,
                        rotate: value.rotate,
                    };
                    case_file['photo' + index + '_later'] = value.upload_later
                        ? true
                        : value.will_not_upload
                          ? null
                          : false;
                }
            });

            case_impression.type = newState.impressionType;
            case_file.facial_scan_file = getFormToken(
                form,
                newState.facialScan.data,
                '$$FILE:facial_scan_file'
            );

            var questionnaire_teeth_array_filtered = questionnaire_teeth_array.filter(function (el) {
                return el != null;
            });

            delete newState.day;
            delete newState.month;
            delete newState.year;
            delete newState.teeth;
            delete newState.files;
            delete newState.facialScan;

            // detail
            const ModifiedName = {
                // "extraction": "attr0",
                // "expansion": "attr1",
                // "interproximal_reduction": "attr2",
                // "distalization": "attr3",
                // "proclination": "attr4",
                // "treatment_simulation": "attr5",
                // "over_jet": "attr6",
                // "over_bite": "attr7",
                // "mid_line": "attr8",
                // "cross_bite": "attr9",
                // "extraction_concat": "attr10",
                // "expansion_concat": "attr11",
                // "comment": "attr12",
                // "clinical_condition_comment": "clinical_cond_comment",
                arch_to_treat: 'attr0',
                aligners_margin_placement1: 'attr3',
                special_instructions1: 'attr47',
            };
            // add the patient_id
            modifiedState['patient_id'] = this.state.current_patient_id;

            Object.entries(newState).forEach(([key, value]) => {
                modifiedKey = key
                    .replace(/(?:^|\.?)([A-Z])/g, function (x, y) {
                        return '_' + y.toLowerCase();
                    })
                    .replace(/^_/, '');
                console.log('modifiedKey => ', modifiedKey);
                if (Object.keys(ModifiedName).includes(modifiedKey)) {
                    // if need to hide clnical_condition_comment if clinical condition does not include "others", do it here
                    const attrName = ModifiedName[modifiedKey];
                    case_detail[attrName] = typeof value === 'object' ? JSON.stringify(value) : value;
                } else if (
                    modifiedKey === 'scanner_brand' ||
                    modifiedKey === 'doctor_id' ||
                    modifiedKey === 'modern_code' ||
                    modifiedKey === 'waybill_number' ||
                    modifiedKey === 'courier_company'
                ) {
                    if (value.length > 0) {
                        case_impression[modifiedKey] = value;
                    }
                } else if (modifiedKey === 'promotion_code') {
                    modifiedState[modifiedKey] = value ? value.trim() : '';
                } else if (modifiedKey === 'draft_file_list') {
                    // ignore draft_file_list
                } else if (modifiedKey === 'patient_photo') {
                    const fileName = '$$FILE:profile_pic';
                    modifiedState['profile_pic'] = {
                        data: getFormToken(form, value.data, fileName),
                        rotate: value.rotate,
                    };
                } else if (modifiedKey === 'not_to_treat1') {
                    case_detail['new_excluded_dentition'] = JSON.parse(JSON.stringify(value.sort())).toString();
                } else if (modifiedKey === 'attachments1') {
                    case_detail['attr1'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.value).replace(/\"/g, '')
                            : 'placeAttachmentsAsNeeded';
                    case_detail['new_excluded_attachments'] = JSON.parse(
                        JSON.stringify(value.doNotPlace.sort())
                    ).toString();
                    case_detail['new_included_attachments'] = JSON.parse(JSON.stringify(value.place.sort())).toString();
                    case_detail['attr2'] =
                        typeof value === 'object' ? JSON.stringify(value.delay.value).replace(/\"/g, '') : 'noDelay';
                    case_detail['attr63'] =
                        typeof value === 'object' ? JSON.stringify(value.delay.stage).replace(/\"/g, '') : '';
                } else if (modifiedKey === 'anterior_posterior_relationship1') {
                    case_detail['attr4'] =
                        typeof value === 'object' ? JSON.stringify(value.r).replace(/\"/g, '') : 'maintain';
                    case_detail['attr5'] =
                        typeof value === 'object' ? JSON.stringify(value.l).replace(/\"/g, '') : 'maintain';
                } else if (modifiedKey === 'spacing_and_crowding1') {
                    case_detail['attr6'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.spacing.value).replace(/\"/g, '')
                            : 'closeAllSpaces';
                    case_detail['attr64'] =
                        typeof value === 'object' ? JSON.stringify(value.spacing.location).replace(/\"/g, '') : '';
                    case_detail['attr7'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveUpper.expand.value).replace(/\"/g, '')
                            : 'asNeeded';
                    case_detail['attr48'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveUpper.expand.teeth).replace(/\"/g, '')
                            : '';
                    case_detail['attr8'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveUpper.procline.value).replace(/\"/g, '')
                            : 'asNeeded';
                    case_detail['attr49'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveUpper.procline.teeth).replace(/\"/g, '')
                            : '';
                    case_detail['attr9'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveUpper.IPRAnterior.value).replace(/\"/g, '')
                            : 'asNeeded';
                    case_detail['attr50'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveUpper.IPRAnterior.teeth).replace(/\"/g, '')
                            : '';
                    case_detail['attr10'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveUpper.IPRPosteriorRight.value).replace(/\"/g, '')
                            : 'asNeeded';
                    case_detail['attr51'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveUpper.IPRPosteriorRight.teeth).replace(/\"/g, '')
                            : '';
                    case_detail['attr11'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveUpper.IPRPosteriorLeft.value).replace(/\"/g, '')
                            : 'asNeeded';
                    case_detail['attr52'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveUpper.IPRPosteriorLeft.teeth).replace(/\"/g, '')
                            : '';
                    case_detail['attr12'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveUpper.extraction.value).replace(/\"/g, '')
                            : 'asNeeded';
                    case_detail['attr53'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveUpper.extraction.teeth).replace(/\"/g, '')
                            : '';
                    case_detail['attr13'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveLower.expand.value).replace(/\"/g, '')
                            : 'asNeeded';
                    case_detail['attr54'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveLower.expand.teeth).replace(/\"/g, '')
                            : '';
                    case_detail['attr14'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveLower.procline.value).replace(/\"/g, '')
                            : 'asNeeded';
                    case_detail['attr55'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveLower.procline.teeth).replace(/\"/g, '')
                            : '';
                    case_detail['attr15'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveLower.IPRAnterior.value).replace(/\"/g, '')
                            : 'asNeeded';
                    case_detail['attr56'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveLower.IPRAnterior.teeth).replace(/\"/g, '')
                            : '';
                    case_detail['attr16'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveLower.IPRPosteriorRight.value).replace(/\"/g, '')
                            : 'asNeeded';
                    case_detail['attr57'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveLower.IPRPosteriorRight.teeth).replace(/\"/g, '')
                            : '';
                    case_detail['attr17'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveLower.IPRPosteriorLeft.value).replace(/\"/g, '')
                            : 'asNeeded';
                    case_detail['attr58'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveLower.IPRPosteriorLeft.teeth).replace(/\"/g, '')
                            : '';
                    case_detail['attr18'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveLower.extraction.value).replace(/\"/g, '')
                            : 'asNeeded';
                    case_detail['attr59'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.crowding.resolveLower.extraction.teeth).replace(/\"/g, '')
                            : '';
                } else if (modifiedKey === 'over_jet1') {
                    case_detail['attr19'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.value).replace(/\"/g, '')
                            : 'maintainInitialOverjet';
                    case_detail['attr20'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.subValue).replace(/\"/g, '') === 'null'
                                ? ''
                                : JSON.stringify(value.subValue).replace(/\"/g, '')
                            : '';
                } else if (modifiedKey === 'openbite1') {
                    let extrudeIntrudePlace = [];
                    let extrudeAnteriorTeeth = [];
                    let intrudePosteriorTeeth = [];
                    if (value.subValue.extrudeAnteriorTeeth.value === true)
                        extrudeIntrudePlace.push('extrudeAnteriorTeeth');
                    if (value.subValue.intrudePosteriorTeeth.value === true)
                        extrudeIntrudePlace.push('intrudePosteriorTeeth');
                    if (value.subValue.placeMiniImplantsTAD.value === true)
                        extrudeIntrudePlace.push('placeMiniImplantsTAD');
                    if (value.subValue.extrudeAnteriorTeeth.upper === true) extrudeAnteriorTeeth.push('upper');
                    if (value.subValue.extrudeAnteriorTeeth.lower === true) extrudeAnteriorTeeth.push('lower');
                    if (value.subValue.intrudePosteriorTeeth.upper === true) intrudePosteriorTeeth.push('upper');
                    if (value.subValue.intrudePosteriorTeeth.lower === true) intrudePosteriorTeeth.push('lower');
                    case_detail['attr21'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.value).replace(/\"/g, '')
                            : 'maintainInitialOpenbite';
                    case_detail['attr22'] =
                        typeof value === 'object' && value.subValue.value !== null
                            ? JSON.stringify(value.subValue.value).replace(/\"/g, '')
                            : '';
                    case_detail['attr23'] = JSON.stringify(extrudeIntrudePlace);
                    case_detail['attr24'] = JSON.stringify(extrudeAnteriorTeeth);
                    case_detail['attr25'] = JSON.stringify(intrudePosteriorTeeth);
                    case_detail['attr60'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.subValue.placeMiniImplantsTAD.input).replace(/\"/g, '')
                            : '';
                } else if (modifiedKey === 'deep_bite1') {
                    let intrudeExtrudePlace = [];
                    let intrudeAnteriorTeeth = [];
                    let extrudePosteriorTeeth = [];
                    if (value.subValue.intrudeAnteriorTeeth.value === true)
                        intrudeExtrudePlace.push('intrudeAnteriorTeeth');
                    if (value.subValue.extrudePosteriorTeeth.value === true)
                        intrudeExtrudePlace.push('extrudePosteriorTeeth');
                    if (value.subValue.placeMiniImplantsTAD.value === true)
                        intrudeExtrudePlace.push('placeMiniImplantsTAD');
                    if (value.subValue.intrudeAnteriorTeeth.upper === true) intrudeAnteriorTeeth.push('upper');
                    if (value.subValue.intrudeAnteriorTeeth.lower === true) intrudeAnteriorTeeth.push('lower');
                    if (value.subValue.extrudePosteriorTeeth.upper === true) extrudePosteriorTeeth.push('upper');
                    if (value.subValue.extrudePosteriorTeeth.lower === true) extrudePosteriorTeeth.push('lower');
                    case_detail['attr26'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.value).replace(/\"/g, '')
                            : 'maintainExistingDeepBite';
                    case_detail['attr27'] =
                        typeof value === 'object' && value.subValue.value !== null
                            ? JSON.stringify(value.subValue.value).replace(/\"/g, '')
                            : '';
                    case_detail['attr28'] = JSON.stringify(intrudeExtrudePlace);
                    case_detail['attr29'] = JSON.stringify(intrudeAnteriorTeeth);
                    case_detail['attr30'] = JSON.stringify(extrudePosteriorTeeth);
                    case_detail['attr61'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.subValue.placeMiniImplantsTAD.input).replace(/\"/g, '')
                            : '';
                } else if (modifiedKey === 'midline1') {
                    let upperLowerChecked = [];
                    if (value.subValue.upper.checked === true) upperLowerChecked.push('upper');
                    if (value.subValue.lower.checked === true) upperLowerChecked.push('lower');
                    case_detail['attr31'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.value).replace(/\"/g, '')
                            : 'maintainInitialMidline';
                    case_detail['attr32'] =
                        typeof value === 'object' && value.subValue.value !== null
                            ? JSON.stringify(value.subValue.value).replace(/\"/g, '')
                            : '';
                    case_detail['attr34'] =
                        typeof value === 'object' && value.subValue.upper.value !== null
                            ? JSON.stringify(value.subValue.upper.value).replace(/\"/g, '')
                            : '';
                    case_detail['attr35'] =
                        typeof value === 'object' && value.subValue.lower.value !== null
                            ? JSON.stringify(value.subValue.lower.value).replace(/\"/g, '')
                            : '';
                    case_detail['attr33'] = JSON.stringify(upperLowerChecked);
                } else if (modifiedKey === 'posterior_crossbite1') {
                    let buttonPressedDirectlyOnAlignerSubValue = [];
                    let cutoutToBondButtonDirectlyOnTeethSubValue = [];
                    if (value.subValue.subValue.buttonPressedDirectlyOnAligner.maxillaryTeeth === true)
                        buttonPressedDirectlyOnAlignerSubValue.push('maxillaryTeeth');
                    if (value.subValue.subValue.buttonPressedDirectlyOnAligner.mandibularTeeth === true)
                        buttonPressedDirectlyOnAlignerSubValue.push('mandibularTeeth');
                    if (value.subValue.subValue.cutoutToBondButtonDirectlyOnTeeth.maxillaryTeeth === true)
                        cutoutToBondButtonDirectlyOnTeethSubValue.push('maxillaryTeeth');
                    if (value.subValue.subValue.cutoutToBondButtonDirectlyOnTeeth.mandibularTeeth === true)
                        cutoutToBondButtonDirectlyOnTeethSubValue.push('mandibularTeeth');
                    case_detail['attr36'] =
                        typeof value === 'object'
                            ? JSON.stringify(value.value).replace(/\"/g, '')
                            : 'maintainInitialCrossbite';
                    case_detail['attr37'] =
                        typeof value === 'object' && value.subValue.value !== null
                            ? JSON.stringify(value.subValue.value).replace(/\"/g, '')
                            : 'noPreferenceShowResultsInSimulator';
                    case_detail['attr38'] =
                        typeof value === 'object' && value.subValue.subValue.value !== null
                            ? JSON.stringify(value.subValue.subValue.value).replace(/\"/g, '')
                            : '';
                    case_detail['attr39'] = JSON.stringify(buttonPressedDirectlyOnAlignerSubValue);
                    case_detail['attr40'] = JSON.stringify(cutoutToBondButtonDirectlyOnTeethSubValue);
                    case_detail['attr46'] =
                        typeof value === 'object' &&
                        value.subValue.subValue.otherMethod &&
                        value.subValue.subValue.otherMethod !== null
                            ? JSON.stringify(value.subValue.subValue.otherMethod).replace(/\"/g, '')
                            : '';
                } else if (modifiedKey === 'auxiliaries1') {
                    case_detail['attr41'] =
                        typeof value === 'object' ? JSON.stringify(value.classIIElastics).replace(/\"/g, '') : 'No';
                    case_detail['attr42'] =
                        typeof value === 'object' ? JSON.stringify(value.classIIIElastics).replace(/\"/g, '') : 'No';
                    let auxiliaries1SubValue = [];
                    if (!(case_detail['attr41'] === 'No' && case_detail['attr42'] === 'No')) {
                        auxiliaries1SubValue.push(value.subValue.upper.value);
                        auxiliaries1SubValue.push(value.subValue.lower.value);
                    }
                    case_detail['attr43'] = JSON.stringify(auxiliaries1SubValue);
                    case_detail['attr44'] =
                        typeof value === 'object' ? JSON.stringify(value.otherElastics.value).replace(/\"/g, '') : 'No';
                    case_detail['attr62'] =
                        typeof value === 'object' ? JSON.stringify(value.otherElastics.comment).replace(/\"/g, '') : '';
                } else if (modifiedKey === 'trio_dim_force') {
                    case_detail['trio_dim_force'] = value;
                } else if (modifiedKey === 'restorative_options') {
                    const restorativeOptResponse = handleRestorativeOptions({ modifiedKey, value: value });
                    console.log('restorativeOptResponse => ', restorativeOptResponse);
                    case_detail['restorative_options'] = restorativeOptResponse.restorativeOptions;
                    case_detail['onlay_position'] = restorativeOptResponse.onlayPosition;
                    case_detail['vertical_dimension_upper_posterior'] =
                        restorativeOptResponse.verticalDimensionUpperPosterior;
                    case_detail['vertical_dimension_lower_posterior'] =
                        restorativeOptResponse.verticalDimensionLowerPosterior;
                } else if (modifiedKey === 'pre_implant_aligment') {
                    let prostheticSpaceVal = handlePreImplantAligment({ modifiedKey, value: value });
                    case_detail['prosthetic_space'] = prostheticSpaceVal;
                } else if (modifiedKey === 'add_on_smile_design') {
                    console.log('add_on_smile_design', value);
                    console.log('data in store => ', this.props.NewPatientData.upSellSmileDesignPrescriptionFormData);
                    const isDataInStoreEmpty = _.isEmpty(
                        this.props.NewPatientData.upSellSmileDesignPrescriptionFormData
                    );
                    console.log(
                        'upSellSmileDesignPrescriptionFormIsValid => ',
                        this.props.NewPatientData.upSellSmileDesignPrescriptionFormIsValid
                    );
                    case_detail['add_on_smile_design'] = value?.value;
                    if (value?.value === 'Yes') {
                        let submitData = isDataInStoreEmpty
                            ? getBaseEmptySmileDesignFormData(this.state.isMarieGroup)
                            : this.props.NewPatientData.upSellSmileDesignPrescriptionFormData;
                        if (saveType !== 'tempSave') {
                            submitData = handleCleanUpAddOnSmileDesignSubValue(
                                this.props.NewPatientData.upSellSmileDesignPrescriptionFormData
                            );
                        }
                        modifiedState['case_smile_design'] = submitData;
                    }
                } else if (modifiedKey === 'up_sell_smile_design_prescription_form_data') {
                    // Skip to next iteration - already handled in 'add_on_smile_design' key
                    return;
                } else {
                    modifiedState[modifiedKey] = value;
                }
            });
            case_detail = Object.fromEntries(
                Object.entries(case_detail).map(([key, value]) => {
                    if (String.isBlank(value) || value === 'null' || value === 'undefined') {
                        return [key, null];
                    }
                    return [key, value];
                })
            );
            this.checkCaseType('handleSave - detail done');

            delete modifiedState.cbct_files;
            modifiedState['case_cbct'] = this.props.NewPatientData.cbctFiles.map((cbct, index) => {
                const fileName = `$$FILE:cbct${index}`;
                cbct.path = getFormToken(form, cbct.path, fileName);
                return cbct;
            });

            modifiedState['date_of_birth'] = date_of_birth;

            case_detail['excluded_dentition'] = questionnaire_teeth_array_filtered + '';
            case_detail['clinical_cond'] = newState['clinical_cond'];
            case_detail['show_upsell_questions'] = shouldShowUpsellForm(
                this.props.userAllowedFeatures?.allowedFeatures
            );

            modifiedState['case_detail'] = case_detail;
            modifiedState['case_file'] = case_file;

            //set impression id on edit mode
            if (this.state.case_impression_id) {
                case_impression['case_impression_id'] = this.state.case_impression_id;
            }

            modifiedState['case_impression'] = case_impression;

            if (saveType === 'tempSave') {
                modifiedState['case_status'] = 'DRAFT';
            } else {
                modifiedState['case_status'] = 'SUBMITTED';
            }

            if (this.props.match?.params?.id) {
                modifiedState['case_id'] = parseInt(this.props.match.params.id);
            }
            modifiedState['case_type'] = this.state.NewCaseType;
            if (modifiedState['case_type'] === null || modifiedState['case_type'] === '') {
                let record = this.state.case_type_null_record;
                record.push("handleSave - modifiedState['case_type']");
                this.setState();
            }

            if (this.state.NewCaseOption) {
                modifiedState['new_case_option'] = this.state.NewCaseOption;
            }
            this.checkCaseType('handleSave - detail done');

            if (newAddress.delivery_id === 'New Address') {
                let newAddressData = {
                    first_name: newAddress.firstName,
                    last_name: newAddress.lastName,
                    country_id: newAddress.country_id,
                    state_province_id: newAddress.state_id,
                    city: newAddress.city,
                    address_1: newAddress.address,
                    postcode: newAddress.zipCode,
                    phone_no: newAddress.phoneNumber,
                    fax_no: newAddress.faxNumber,
                    case_id: modifiedState['case_id'],
                };
                try {
                    let deliveryNewAddress = (await axios.post(`case/address`, newAddressData)).data
                        .delivery_address_id;
                    modifiedState['delivery_address_id'] = deliveryNewAddress;
                } catch (e) {
                    this.setState({
                        savingData: false,
                    });
                    if (modifiedState.case_status !== 'DRAFT') {
                        if (Array.isArray(e.response?.data?.invalid)) {
                            this.props.showSnackbar('Please enter all required fields in Delivery tab', 'error');
                        } else {
                            this.props.showSnackbar(e.response?.data?.message ?? e.message ?? e, 'error');
                        }
                        console.error(e.response);
                        throw e;
                    } else {
                        modifiedState['delivery_address_id'] = null;
                    }
                }
            } else if (newAddress.delivery_id === null || typeof newAddress.delivery_id !== 'number') {
                this.setState({
                    savingData: false,
                });
                this.props.showSnackbar('Please select delivery address', 'error');
                throw new Error('Please select delivery address');
            } else {
                modifiedState['delivery_address_id'] = newAddress.delivery_id;
            }

            this.checkCaseType('handleSave - address done');

            try {
                if (this.state.NewCaseType === 'RETAINER') {
                    const { prescriptionFormValues, retainerRequestId, supportedRetainerTypes } =
                        this.props.diffRetainer;
                    if (saveType !== 'tempSave') {
                        const validateFunc = this.props.diffRetainer.targetTypeRetainerValidationFunc;
                        if (typeof validateFunc === 'function' && validateFunc) {
                            const isValid = await validateFunc();
                            if (!isValid) {
                                throw new Error('Please fill prescription form');
                            }
                        }
                    }

                    modifiedState['retainer_request'] = { ...initRetainerReqFormValue };
                    if (prescriptionFormValues && prescriptionFormValues.impressionType) {
                        modifiedState['retainer_request'] = prescriptionFormValues;
                    }
                    const retainerReqPrescriptionNote = this.props.NewPatientData.retainerRequestPrescriptionNote;
                    let isValidRetainerPrescriptionData = false;
                    // console.log("retainerReqPrescriptionNote", retainerReqPrescriptionNote)
                    isValidRetainerPrescriptionData =
                        retainerReqPrescriptionNote &&
                        retainerReqPrescriptionNote.retainer_request_id &&
                        retainerReqPrescriptionNote?.impression_type;
                    if (isValidRetainerPrescriptionData && !prescriptionFormValues.impressionType) {
                        // handle user not clicked on retainer's prescription notes tab
                        const retainerReqHandler = new RetainerRequestHandler({
                            impressionType: retainerReqPrescriptionNote?.impression_type,
                            caseId: this.props.match?.params?.id,
                        });
                        const convertedData = retainerReqHandler.convertFormValueFromNewPatientStoreData(
                            retainerReqPrescriptionNote,
                            supportedRetainerTypes
                        );
                        // console.log(JSON.stringify(convertedData , null , 4))
                        modifiedState['retainer_request'] = convertedData;
                        modifiedState['retainer_request']['retainer_request_id'] =
                            retainerReqPrescriptionNote.retainer_request_id;
                    }
                    if (retainerRequestId) {
                        modifiedState['retainer_request']['retainer_request_id'] = retainerRequestId;
                    }
                    if (modifiedState['retainer_request'] && modifiedState['retainer_request']['retainer_request_id']) {
                        if (
                            (!prescriptionFormValues || !prescriptionFormValues.impressionType) &&
                            !isValidRetainerPrescriptionData
                        ) {
                            const initRetainerReq = getInitRetainerReq(
                                modifiedState['retainer_request']['retainer_request_id']
                            );
                            modifiedState['retainer_request'] = { ...initRetainerReq };
                        }
                    }
                }
            } catch (error) {
                this.props.showSnackbar('Please fill prescription form', 'error');
                return;
            }

            try {
                if (smileDesignProductListArray.includes(this.state.NewCaseType)) {
                    modifiedState['case_smile_design'] = this.props.smileDesign.smileDesignPrescriptionFormData;
                    delete modifiedState['case_detail'];
                }
                if (this.isCaseTypeSelfDesign()) {
                    delete modifiedState['case_detail'];
                    delete modifiedState['case_file'];
                    delete modifiedState['case_impression'];
                }
                form.append('body', JSON.stringify(modifiedState));
                formCheckPromotionCode.append('promotion_code', modifiedState.promotion_code);
                formCheckPromotionCode.append('treatment_option', modifiedState.case_type);

                if (modifiedState.case_status !== 'DRAFT' && modifiedState.promotion_code.trim().length > 0) {
                    let checkPromotionCodeResult = await axios.post(
                        `case/promotionCode/newCaseSubmitPromotionCodeCheck`,
                        formCheckPromotionCode
                    );

                    if (!(checkPromotionCodeResult.data.success && checkPromotionCodeResult.data.valid)) {
                        this.setState({
                            showAlert: true,
                            alertMessage: checkPromotionCodeResult.data.errMsg,
                        });
                    }
                }
                this.checkCaseType('handleSave - promotion code done');
                // Useless gard here: the state will not update immediately in above so always !false === true here.
                // The guard works in submit(e) function
                // Not delete !this.state.showAlert to prevent unexpected behavior here
                if (!this.state.showAlert) {
                    if (this.state.case_type_null_record.length > 0) {
                        const caseTypeNullLog = {
                            platform: PLATFORM,
                            module: MODULE,
                            action: 'null case type',
                            detail: this.state.case_type_null_record,
                            para1: '',
                            para2: '',
                            para3: '',
                            para4: '',
                            para5: '',
                        };
                        await this.props.traceLog(caseTypeNullLog);
                    }
                    const createCaseResult = await axios.post('case', form, {
                        onUploadProgress: this.progressBarRef.current?.onProgressChange,
                    });
                    // console.log("pause submission")

                    this.setState({
                        saved: true,
                    });
                    if (modifiedState.case_status === 'DRAFT') {
                        this.props.showSnackbar('Draft saved', 'success', true);
                    } else {
                        this.props.showSnackbar('Case submitted', 'success', true);
                    }
                    if (createCaseResult.data.success) {
                        if (createCaseResult.data.result.case_status === 'DRAFT') {
                            this.props.history.push(`/`);
                        } else {
                            // this.props.history.push(`/patients/${createCaseResult.data.result.patient_id}/${createCaseResult.data.result.case_id}/View`);
                            this.props.history.push(`/patients/${createCaseResult.data.result.case_id}`);
                        }
                    } else {
                        this.props.history.replace('/');
                    }
                }
                this.addTraceLogToState('save function end');

                const traceLogData = {
                    platform: PLATFORM,
                    module: MODULE,
                    action: ACTION,
                    detail: this.state.traceLogs,
                    para1: '',
                    para2: '',
                    para3: '',
                    para4: '',
                    para5: '',
                };
                this.props.traceLog(traceLogData);
            } catch (err) {
                this.setState({
                    savingData: false,
                });
                console.error(err);
                const baseErrMsg = err.response?.data?.message ?? err.message ?? err;
                let isReload = baseErrMsg === ERROR.DUPLICATE_CASE_SUBMISSION ? true : false;
                const errMsg = this.getErrorMsg(err, baseErrMsg);
                if (isReload) {
                    this.setState({ isExcludeDraftWarning: true });
                    let url = this.props.match?.params?.id ? `/patients/${this.props.match.params.id}` : '/';
                    this.props.openRedirectUserModal({
                        title: this.get('@PatientInfo.msg.duplicateCaseSubmissionTitle'),
                        message: this.get('@PatientInfo.msg.duplicateCaseSubmissionMessage'),
                        modalOnCloseCallbackFunc: () => this.props.history.push(url),
                        showOk: false,
                    });
                    return;
                }
                this.props.showSnackbar(errMsg, 'error');
                await sendLogToServer(err);
            } finally {
                if (newAddress.delivery_id === 'New Address' && modifiedState['delivery_address_id']) {
                    this.props.saveAddressId(modifiedState['delivery_address_id']);
                }
            }
        } finally {
            this.setState({
                uploading: false,
            });
        }
    }
    addTraceLogToState(stepNumber) {
        const newTraceLog = this.createTraceLog(stepNumber);
        this.setState((prevState) => ({
            traceLogs: [...prevState.traceLogs, newTraceLog],
        }));
    }

    handleSaveRetainerFormIntoStore() {
        const { diffRetainer, NewPatientData } = this.props;
        const {
            prescriptionFormValues,
            supportedRetainerTypes,
            toothBiteRamp,
            specialInstruction,
            retainerRequestId,
            upperToothBiteRamp,
            lowerToothBiteRamp,
        } = diffRetainer;
        const { retainerRequestPrescriptionNote } = NewPatientData;
        if (!prescriptionFormValues || !prescriptionFormValues.impressionType) return;
        const caseId = this.props.match.params.id || null;
        let targetRetainerReqId = retainerRequestPrescriptionNote?.retainer_request_id || null;
        if (retainerRequestId) {
            targetRetainerReqId = retainerRequestId;
        }
        const teethSelections = {
            toothBiteRamp: toothBiteRamp || [],
            upperToothBiteRamp: upperToothBiteRamp || [],
            lowerToothBiteRamp: lowerToothBiteRamp || [],
        };
        const retainerRequestHandler = new RetainerRequestHandler({
            impressionType: prescriptionFormValues.impressionType,
            caseId,
        });
        const payload = retainerRequestHandler.getRetainerReqFormValuesForDraftCaseSummaryDisplay(
            prescriptionFormValues,
            targetRetainerReqId,
            supportedRetainerTypes,
            teethSelections,
            specialInstruction
        );
        this.props.saveRetainerRequestPrescriptionNote(payload);
    }

    // Determines whether Q1 has Guided Veneer selected, including SIMPLE upsell forms.
    isCeramicVeneersSelected() {
        const formValues = this.props.smileDesign.getSmileDesignPrescriptionFormValues();
        const plannedRestorationSolution =
            formValues?.plannedRestorationSolution ||
            (this.state.NewCaseType === 'SIMPLE'
                ? this.props.NewPatientData.upSellSmileDesignPrescriptionFormData?.plannedRestorationSolution
                : '');
        return plannedRestorationSolution === 'option.guidedVeneerTreatment';
    }

    // Changes workflow steps and displays scan guidance before entering Impression.
    handleChangeTab(tab) {
        if (tab === WORKFLOW_TAB.IMPRESSION && this.isCeramicVeneersSelected()) {
            this.props.showGuidedVeneerScanGuidance();
        }
        this.addTraceLogToState('tab :' + tab);
        this.props.setVisitedTabs(tab);

        this.handleSaveRetainerFormIntoStore();

        this.setState({ tabMode: tab });
        this.checkCaseType(`handleChangeTab - ${tab}`);
    }

    handleValidation(err) {
        this.setState({ error: err });
    }

    checkCaseType(message) {
        if (this.state.NewCaseType === null || this.state.NewCaseType === '') {
            let rec = this.state.case_type_null_record;
            rec.push(message);
            this.setState({ case_type_null_record: rec });
        }
    }

    isSamePatientCreateNewCaseAction() {
        return this.props.caseAction === newCaseSamePatientAction;
    }

    isShowTreatmentOption() {
        return !this.isSamePatientCreateNewCaseAction();
    }

    disabledNewPatientInfoInputObj() {
        const isDisabled = this.isSamePatientCreateNewCaseAction();
        const disabledObj = {
            firstName: isDisabled,
            lastName: isDisabled,
            gender: isDisabled,
            dateOfBirth: isDisabled,
            remarks: isDisabled,
            dr_remark: isDisabled,
            profilePic: isDisabled,
        };
        return disabledObj;
    }

    isExistPatientIdFromUrl() {
        return this.state.current_patient_id;
    }

    isMissingPatientIdFromUrl() {
        return !this.isExistPatientIdFromUrl();
    }

    isExistCaseIdFromUrl() {
        return this.props.match.params.id;
    }

    isMissingCaseIdFromUrl() {
        return !this.isExistCaseIdFromUrl();
    }

    async GetCurrentPatientList(doctorId) {
        //canStartCase=true 时 ，根据 DRAFT / ENDED / treatment expired 相关逻辑筛选 patient ，false不会。
        let url = `/patient/GetPatientListByDoctor${this.state.role !== 'DR' ? `?doctor_id=${doctorId}&canStartCase=true` : `?canStartCase=false`}`;
        const patientListByDoctorId = await axios.get(url);
        return patientListByDoctorId.data.success ? patientListByDoctorId.data.result : [];
    }

    async GetPatientCanSubmitSmileDesignCaseList(doctorId) {
        if (doctorId === null || doctorId === undefined || doctorId === '') {
            return [];
        }
        let url = `/patient/GetPatientCanSubmitSmileDesignCaseList${this.state.role !== 'DR' ? `?doctor_id=${doctorId}&canStartCase=true` : `?canStartCase=true`}`;
        // const response = await axios.get(url);
        // response.data.success ? response.data.result : []
        return [];
    }

    async GetPatientCanSubmitAlignerCaseIfSmileDesignCaseList(doctorId) {
        if (doctorId === null || doctorId === undefined || doctorId === '') {
            return [];
        }
        let url = `/patient/GetPatientCanSubmitAlignerCaseIfSmileDesignCaseList${this.state.role !== 'DR' ? `?doctor_id=${doctorId}&canStartCase=true` : `?canStartCase=true`}`;
        // const response = await axios.get(url);
        // response.data.success ? response.data.result : []
        return [];
    }

    handleTabsWhenMount(data = null) {
        console.log('handle tabs here');
        console.log('data => ', data);
        const caseData = data?.case[0] || null;
        if (caseData?.case_type === CASE_TYPE.RETAINER) {
            this.setState({ tabs: RETAINER_WORKFLOW_TABS });
            return;
        }
        if (caseData?.case_type === CASE_TYPE.SELF_DESIGN) {
            this.setState({ tabs: SELF_DESIGN_WORKFLOW_TABS });
            return;
        }
    }

    /**
     * Initializes the New Patient case data.
     */
    async componentDidMount() {
        // when start to load, pre-set current login user id first.
        let currentDoctorId = parseInt(JSON.parse(localStorage.getItem('auth-token')));

        let isMarieGroup = JSON.parse(localStorage.getItem('isMarieGroup'));
        const auth = this.props.auth;
        console.log('this.props.match.params.type => ', this.props.match.params.type);
        if (this.props?.match?.params?.type) {
            const newCaseType = this.props.match.params.type;
            if (newCaseType === CASE_TYPE.RETAINER) {
                this.setState({ tabs: RETAINER_WORKFLOW_TABS });
                this.setState({ isValidatedOnMount: true });
            } else if (newCaseType === CASE_TYPE.SELF_DESIGN) {
                this.setState({ tabs: SELF_DESIGN_WORKFLOW_TABS });
                this.setState({ isValidatedOnMount: true });
            }
        }
        let data = null; // store case to this variable to avoid calling case API multiple times
        //Purpose: check submited. If not, navigate to patientInfo
        if (this.props.match.params.id) {
            const caseData = await safeGet(`case/${this.props.match.params.id}`);
            if (!caseData.success && caseData.message === ERROR.CASE_CANCELLED) {
                this.props.openRedirectUserModal({
                    title: this.get('@PatientInfo.msg.caseCancelledTitle'),
                    message: this.get('@PatientInfo.msg.caseCancelledMessage'),
                    modalOnCloseCallbackFunc: () => this.props.history.push('/'),
                    showOk: false,
                });
                return;
            }
            data = caseData; // store here
            const currentCaseBySearched = caseData.case[0];
            this.setState({ current_patient_id: currentCaseBySearched.patient_id });
            let { history } = this.props;
            if (currentCaseBySearched.case_status !== 'DRAFT') {
                this.setState({ isDraft: false });
                return history.push(`/patients/${this.props.match.params.id}`);
            }
        }
        if (data) {
            this.handleTabsWhenMount(data);
        }

        if (this.state.tabMode === 'photos') {
            this.scrollIntoView();
        }
        this.addTraceLogToState('componentDidMount start');
        let country, state, addressList, draftFileList;
        try {
            country = (await axios.get(`res/country`)).data.country;
            state = (await axios.get(`res/state_province`)).data.state_province;
            addressList = (
                await axios.get(
                    `case/address${isNaN(this.props.match.params.id) ? '' : `?case_id=${this.props.match.params.id}`}`
                )
            ).data.address;
            draftFileList = (
                await axios.get(
                    `mobile_app/doctor/draft_file_list${isNaN(this.props.match.params.id) ? '' : `?case_id=${this.props.match.params.id}`}`
                )
            ).data.draft_file_list;
            this.setState({ countryList: country, stateList: state, addressList: addressList, draftFileList });
        } catch (err) {
            if (err.response && err.response.statusText === 'Unauthorized') {
                localStorage.removeItem('auth-token');
                localStorage.removeItem('expirationDate');
                localStorage.removeItem('role');
                this.props.history.push('/login');
            }
        }
        if (this.props.caseAction != undefined && String.isNotBlank(this.state.current_patient_id)) {
            try {
                let patientData = await axios.get(`/patient/${this.state.current_patient_id}`);
                if (patientData.data.success) {
                    let intialState = {};
                    intialState['firstName'] = patientData.data.result.first_name;
                    intialState['lastName'] = patientData.data.result.last_name;
                    intialState['gender'] = patientData.data.result.gender;
                    const splitDate = patientData.data.result.date_of_birth.split('-');
                    intialState['day'] = parseInt(splitDate[0]);
                    intialState['month'] = parseInt(splitDate[1]);
                    intialState['year'] = parseInt(splitDate[2]);
                    intialState['remarks'] = patientData.data.result.remarks;
                    intialState['patientPhoto'] = {
                        data: patientData.data.result.profile_pic
                            ? /^https?:\/\//.test(patientData.data.result.profile_pic)
                                ? patientData.data.result.profile_pic
                                : join(ApiServerUrl, patientData.data.result.profile_pic)
                            : null,
                        uploaded: true,
                        rotate: 0,
                    };
                    this.props.setTempData(intialState);
                }
                this.setState({ patientInfo: 'newCaseSamePatient', NewCaseType: this.props.match.params.type });
            } catch (ex) {}
        }
        let {
            data: { rayFiles },
        } = await axios.get('/case/getRayFiles/' + (this.props.match.params.id ?? '0'));
        if (rayFiles) {
            this.setState({ rayFiles: rayFiles });
        }

        let chosenDraftFile = 0;
        let delivery_id = 'New Address';
        if (data) {
            try {
                currentDoctorId = data.case[0].created_by;
                delivery_id = data.case[0].delivery_address_id;
            } catch (err) {
                if (err.response && err.response.statusText === 'Unauthorized') {
                    localStorage.removeItem('auth-token');
                    localStorage.removeItem('expirationDate');
                    localStorage.removeItem('role');
                    this.props.history.push('/login');
                }
            }
            if (data && data.case.length > 0) {
                if (data.case?.[0]?.case_impression?.[0]?.[0]?.case_impression_id) {
                    this.setState({
                        case_impression_id: data.case?.[0]?.case_impression?.[0]?.[0]?.case_impression_id,
                    });
                }

                if (data.case?.[0]?.case_detail?.[0]?.[0]?.excluded_dentition) {
                    data.case[0].excluded_dentition = data.case?.[0]?.case_detail?.[0]?.[0]?.excluded_dentition
                        .split(',')
                        .map((x) => +x);
                } else {
                    data.case[0].excluded_dentition = [];
                }
            }

            if (data && this.state.patientInfo == null) {
                let intialState = {};
                // set patient info record
                intialState['enableRaySelectChoose3dFile'] = data.case[0].enable_ray_select_choose3d_file;

                intialState['isRayCase'] = data.case[0].is_ray_case;
                intialState['caseRfsId'] = data.case[0].case_rfs_id;
                intialState['promotionCode'] = data.case[0].promotion_code;
                intialState['gender'] = data.case[0].gender;
                intialState['lastName'] = data.case[0].last_name;
                intialState['firstName'] = data.case[0].first_name;
                intialState['case_type_id'] = data.case[0].case_type_id;

                intialState['day'] = parseInt(data.case[0].date_of_birth.split('-')[0]);
                intialState['month'] = parseInt(data.case[0].date_of_birth.split('-')[1]);
                intialState['year'] = parseInt(data.case[0].date_of_birth.split('-')[2]);
                intialState['remarks'] = data.case[0].remarks;
                intialState['dr_remark'] = data.case[0].dr_remark;
                intialState['patientPhoto'] = {
                    data: data.case[0].profile_pic
                        ? /^https?:\/\//.test(data.case[0].profile_pic)
                            ? data.case[0].profile_pic
                            : join(ApiServerUrl, data.case[0].profile_pic)
                        : null,
                    uploaded: true,
                    rotate: 0,
                };

                if (
                    !data.case?.[0]?.case_detail?.[0] === null &&
                    data.case?.[0]?.case_detail?.[0]?.[0]?.new_prescription_notes_flag === false
                ) {
                    //set patient questionnaire record for case using old questionnaire
                    intialState['extraction'] = data.case?.[0]?.case_detail?.[0]?.[0]?.attr0
                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr0
                        : 'primary';
                    intialState['expansion'] = data.case?.[0]?.case_detail?.[0]?.[0]?.attr1
                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr1
                        : 'primary';
                    intialState['interproximalReduction'] = data.case?.[0]?.case_detail?.[0]?.[0]?.attr2
                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr2
                        : 'primary';
                    intialState['distalization'] = data.case?.[0]?.case_detail?.[0]?.[0]?.attr3
                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr3
                        : 'primary';
                    intialState['proclination'] = data.case?.[0]?.case_detail?.[0]?.[0]?.attr4
                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr4
                        : 'primary';
                    intialState['treatmentSimulation'] = data.case?.[0]?.case_detail?.[0]?.[0]?.attr5
                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr5
                        : 'primary';
                    intialState['overJet'] = data.case?.[0]?.case_detail?.[0]?.[0]?.attr6
                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr6
                        : 'maintain';
                    intialState['overBite'] = data.case?.[0]?.case_detail?.[0]?.[0]?.attr7
                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr7
                        : 'maintain';
                    try {
                        intialState['midLine'] = data.case?.[0]?.case_detail?.[0]?.[0]?.attr8
                            ? JSON.parse(data.case?.[0]?.case_detail?.[0]?.[0]?.attr8)
                            : [];
                    } catch (err) {}
                    intialState['crossBite'] = data.case?.[0]?.case_detail?.[0]?.[0]?.attr9
                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr9
                        : 'maintain';
                    let modifiedTeethData = [...this.props.NewPatientData.teeth];
                    modifiedTeethData = modifiedTeethData.filter((v, index) => {
                        if (data.case[0].excluded_dentition.includes(index)) {
                            return (v['checked'] = true);
                        } else {
                            return v;
                        }
                    });
                    intialState['comment'] = data.case?.[0]?.case_detail?.[0]?.[0]?.attr12 ?? '';
                    intialState['extractionConcat'] = data.case?.[0]?.case_detail?.[0]?.[0]?.attr10
                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr10
                        : '';
                    intialState['expansionConcat'] = data.case?.[0]?.case_detail?.[0]?.[0]?.attr11
                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr11
                        : '';
                    intialState['teeth'] = modifiedTeethData;
                    intialState['clinical_cond'] = data.case?.[0]?.case_detail?.[0]?.[0]?.clinical_cond
                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.clinical_cond
                        : '';
                    intialState['clinicalConditionComment'] =
                        data.case?.[0]?.case_detail?.[0]?.[0]?.clinical_cond_comment ?? '';
                } else if (
                    !(
                        data.case?.[0]?.case_detail?.[0] === null ||
                        (data.case?.[0]?.case_detail?.[0]?.[0]?.new_prescription_notes_flag === false &&
                            data.case?.[0]?.case_status === 'DRAFT')
                    )
                ) {
                    const __caseDetailRow = data.case?.[0]?.case_detail?.[0]?.[0];
                    if (__caseDetailRow && typeof __caseDetailRow === 'object') {
                        for (const __k of Object.keys(__caseDetailRow)) {
                            if (__caseDetailRow[__k] === 'null' || __caseDetailRow[__k] === 'undefined') {
                                __caseDetailRow[__k] = null;
                            }
                        }
                    }
                    //set patient prescription notes record
                    intialState['archToTreat'] = data.case?.[0]?.case_detail?.[0]?.[0]?.attr0
                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr0
                        : null;
                    var newExcludedDentitionArray = [];
                    if (data.case?.[0]?.case_detail?.[0]?.[0]?.new_excluded_dentition !== '') {
                        var newExcludedDentitionArray =
                            data.case?.[0]?.case_detail?.[0]?.[0]?.new_excluded_dentition.split(',');
                        for (var a in newExcludedDentitionArray) {
                            newExcludedDentitionArray[a] = parseInt(newExcludedDentitionArray[a], 10);
                        }
                    }
                    intialState['notToTreat1'] = newExcludedDentitionArray;

                    var doNotPlaceArray = [],
                        placeArray = [];
                    if (data.case?.[0]?.case_detail?.[0]?.[0]?.new_excluded_attachments !== '') {
                        var doNotPlaceArray =
                            data.case?.[0]?.case_detail?.[0]?.[0]?.new_excluded_attachments.split(',');
                        for (var a in doNotPlaceArray) {
                            doNotPlaceArray[a] = parseInt(doNotPlaceArray[a], 10);
                        }
                    }

                    if (data.case?.[0]?.case_detail?.[0]?.[0]?.new_included_attachments !== '') {
                        var placeArray = data.case?.[0]?.case_detail?.[0]?.[0]?.new_included_attachments.split(',');
                        for (var a in placeArray) {
                            placeArray[a] = parseInt(placeArray[a], 10);
                        }
                    }

                    intialState['attachments1'] = {
                        value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr1
                            ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr1
                            : 'placeAttachmentsAsNeeded',
                        doNotPlace: doNotPlaceArray,
                        place: placeArray,
                        delay: {
                            value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr2
                                ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr2
                                : 'noDelay',
                            stage: data.case?.[0]?.case_detail?.[0]?.[0]?.attr63
                                ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr63
                                : '',
                        },
                    };
                    intialState['anteriorPosteriorRelationship1'] = {
                        r: data.case?.[0]?.case_detail?.[0]?.[0]?.attr4
                            ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr4
                            : null,
                        l: data.case?.[0]?.case_detail?.[0]?.[0]?.attr5
                            ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr5
                            : null,
                    };
                    intialState['spacingAndCrowding1'] = {
                        spacing: {
                            value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr6
                                ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr6
                                : null,
                            location: data.case?.[0]?.case_detail?.[0]?.[0]?.attr64
                                ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr64
                                : '',
                        },
                        crowding: {
                            resolveUpper: {
                                expand: {
                                    value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr7
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr7
                                        : null,
                                    teeth: data.case?.[0]?.case_detail?.[0]?.[0]?.attr48
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr48
                                        : '',
                                },
                                procline: {
                                    value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr8
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr8
                                        : null,
                                    teeth: data.case?.[0]?.case_detail?.[0]?.[0]?.attr49
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr49
                                        : '',
                                },
                                IPRAnterior: {
                                    value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr9
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr9
                                        : null,
                                    teeth: data.case?.[0]?.case_detail?.[0]?.[0]?.attr50
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr50
                                        : '',
                                },
                                IPRPosteriorRight: {
                                    value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr10
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr10
                                        : null,
                                    teeth: data.case?.[0]?.case_detail?.[0]?.[0]?.attr51
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr51
                                        : '',
                                },
                                IPRPosteriorLeft: {
                                    value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr11
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr11
                                        : null,
                                    teeth: data.case?.[0]?.case_detail?.[0]?.[0]?.attr52
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr52
                                        : '',
                                },
                                extraction: {
                                    value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr12
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr12
                                        : null,
                                    teeth: data.case?.[0]?.case_detail?.[0]?.[0]?.attr53
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr53
                                        : '',
                                },
                            },
                            resolveLower: {
                                expand: {
                                    value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr13
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr13
                                        : null,
                                    teeth: data.case?.[0]?.case_detail?.[0]?.[0]?.attr54
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr54
                                        : '',
                                },
                                procline: {
                                    value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr14
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr14
                                        : null,
                                    teeth: data.case?.[0]?.case_detail?.[0]?.[0]?.attr55
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr55
                                        : '',
                                },
                                IPRAnterior: {
                                    value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr15
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr15
                                        : null,
                                    teeth: data.case?.[0]?.case_detail?.[0]?.[0]?.attr56
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr56
                                        : '',
                                },
                                IPRPosteriorRight: {
                                    value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr16
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr16
                                        : null,
                                    teeth: data.case?.[0]?.case_detail?.[0]?.[0]?.attr57
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr57
                                        : '',
                                },
                                IPRPosteriorLeft: {
                                    value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr17
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr17
                                        : null,
                                    teeth: data.case?.[0]?.case_detail?.[0]?.[0]?.attr58
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr58
                                        : '',
                                },
                                extraction: {
                                    value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr18
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr18
                                        : null,
                                    teeth: data.case?.[0]?.case_detail?.[0]?.[0]?.attr59
                                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr59
                                        : '',
                                },
                            },
                        },
                    };
                    intialState['overJet1'] = {
                        value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr19
                            ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr19
                            : 'maintainInitialOverjet',
                        subValue: data.case?.[0]?.case_detail?.[0]?.[0]?.attr20
                            ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr20
                            : '',
                    };
                    intialState['alignersMarginPlacement1'] = data.case?.[0]?.case_detail?.[0]?.[0]?.attr3
                        ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr3
                        : 'coverageExtending';
                    intialState['posteriorCrossbite1'] = {
                        value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr36
                            ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr36
                            : 'maintainInitialCrossbite',
                        subValue: {
                            value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr37
                                ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr37
                                : 'noPreferenceShowResultsInSimulator',
                            subValue: {
                                value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr38
                                    ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr38
                                    : null,
                                buttonPressedDirectlyOnAligner: {
                                    maxillaryTeeth:
                                        data.case?.[0]?.case_detail?.[0]?.[0]?.attr39 &&
                                        data.case?.[0]?.case_detail?.[0]?.[0]?.attr39.includes('maxillaryTeeth')
                                            ? true
                                            : false,
                                    mandibularTeeth:
                                        data.case?.[0]?.case_detail?.[0]?.[0]?.attr39 &&
                                        data.case?.[0]?.case_detail?.[0]?.[0]?.attr39.includes('mandibularTeeth')
                                            ? true
                                            : false,
                                },
                                cutoutToBondButtonDirectlyOnTeeth: {
                                    maxillaryTeeth:
                                        data.case?.[0]?.case_detail?.[0]?.[0]?.attr40 &&
                                        data.case?.[0]?.case_detail?.[0]?.[0]?.attr40.includes('maxillaryTeeth')
                                            ? true
                                            : false,
                                    mandibularTeeth:
                                        data.case?.[0]?.case_detail?.[0]?.[0]?.attr40 &&
                                        data.case?.[0]?.case_detail?.[0]?.[0]?.attr40.includes('mandibularTeeth')
                                            ? true
                                            : false,
                                },
                                otherMethod: data.case?.[0]?.case_detail?.[0]?.[0]?.attr46 || '',
                            },
                        },
                    };
                    let auxiliariesAttr43 = [];
                    try {
                        const parsedAttr43 = JSON.parse(data.case?.[0]?.case_detail?.[0]?.[0]?.attr43);
                        if (Array.isArray(parsedAttr43)) {
                            auxiliariesAttr43 = parsedAttr43.filter((a) => typeof a === 'string');
                        }
                    } catch (_) {
                        auxiliariesAttr43 = [];
                    }
                    intialState['auxiliaries1'] = {
                        classIIElastics: data.case?.[0]?.case_detail?.[0]?.[0]?.attr41
                            ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr41
                            : null,
                        classIIIElastics: data.case?.[0]?.case_detail?.[0]?.[0]?.attr42
                            ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr42
                            : null,
                        subValue: {
                            upper: {
                                value: auxiliariesAttr43.find((a) => a.startsWith('upper')),
                            },
                            lower: {
                                value: auxiliariesAttr43.find((a) => a.startsWith('lower')),
                            },
                        },
                        otherElastics: {
                            value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr44
                                ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr44
                                : null,
                            comment: data.case?.[0]?.case_detail?.[0]?.[0]?.attr62
                                ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr62
                                : '',
                        },
                    };
                    intialState['openbite1'] = {
                        value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr21
                            ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr21
                            : 'maintainInitialOpenbite',
                        subValue: {
                            value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr22
                                ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr22
                                : null,
                            extrudeAnteriorTeeth: {
                                value:
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr23 &&
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr23.includes('extrudeAnteriorTeeth')
                                        ? true
                                        : false,
                                upper:
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr24 &&
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr24.includes('upper')
                                        ? true
                                        : false,
                                lower:
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr24 &&
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr24.includes('lower')
                                        ? true
                                        : false,
                            },
                            intrudePosteriorTeeth: {
                                value:
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr23 &&
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr23.includes('intrudePosteriorTeeth')
                                        ? true
                                        : false,
                                upper:
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr25 &&
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr25.includes('upper')
                                        ? true
                                        : false,
                                lower:
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr25 &&
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr25.includes('lower')
                                        ? true
                                        : false,
                            },
                            placeMiniImplantsTAD: {
                                value:
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr23 &&
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr23.includes('placeMiniImplantsTAD')
                                        ? true
                                        : false,
                                input: data.case?.[0]?.case_detail?.[0]?.[0]?.attr60
                                    ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr60
                                    : '',
                            },
                        },
                    };
                    intialState['deepBite1'] = {
                        value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr26
                            ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr26
                            : 'maintainExistingDeepBite',
                        subValue: {
                            value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr27
                                ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr27
                                : null,
                            intrudeAnteriorTeeth: {
                                value:
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr28 &&
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr28.includes('intrudeAnteriorTeeth')
                                        ? true
                                        : false,
                                upper:
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr29 &&
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr29.includes('upper')
                                        ? true
                                        : false,
                                lower:
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr29 &&
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr29.includes('lower')
                                        ? true
                                        : false,
                            },
                            extrudePosteriorTeeth: {
                                value:
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr28 &&
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr28.includes('extrudePosteriorTeeth')
                                        ? true
                                        : false,
                                upper:
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr30 &&
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr30.includes('upper')
                                        ? true
                                        : false,
                                lower:
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr30 &&
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr30.includes('lower')
                                        ? true
                                        : false,
                            },
                            placeMiniImplantsTAD: {
                                value:
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr28 &&
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr28.includes('placeMiniImplantsTAD')
                                        ? true
                                        : false,
                                input: data.case?.[0]?.case_detail?.[0]?.[0]?.attr61
                                    ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr61
                                    : '',
                            },
                        },
                    };
                    intialState['midline1'] = {
                        value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr31
                            ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr31
                            : 'maintainInitialMidline',
                        subValue: {
                            value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr32
                                ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr32
                                : '',
                            upper: {
                                checked:
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr33 &&
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr33.includes('upper')
                                        ? true
                                        : false,
                                value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr34
                                    ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr34
                                    : '',
                            },
                            lower: {
                                checked:
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr33 &&
                                    data.case?.[0]?.case_detail?.[0]?.[0]?.attr33.includes('lower')
                                        ? true
                                        : false,
                                value: data.case?.[0]?.case_detail?.[0]?.[0]?.attr35
                                    ? data.case?.[0]?.case_detail?.[0]?.[0]?.attr35
                                    : '',
                            },
                        },
                    };
                    if (data.case[0].case_detail[0][0]?.trio_dim_force) {
                        const trioDimForce = data.case[0].case_detail[0][0].trio_dim_force;
                        intialState['trioDimForce'] = trioDimForce;
                    }
                    const caseDetailData = data.case[0].case_detail[0][0];
                    const caseData = data.case[0];
                    intialState['restorativeOptions'] = handleSetRestorativeOptionsData(caseDetailData);
                    intialState['preImplantAligment'] = handleSetPreImplantAligmentData(caseDetailData);
                    intialState['specialInstructions1'] = data.case?.[0]?.case_detail?.[0]?.[0]?.attr47 ?? '';
                    const addOnValue = handleSetAddOnSmileDesignValue(caseData?.case_smile_design ?? null);
                    intialState['addOnSmileDesign'] = { value: addOnValue };
                    if (addOnValue === 'Yes') {
                        if (caseData && caseData?.case_smile_design) {
                            let formData = extractSmileDesignFormDataForUpsell(caseData?.case_smile_design);
                            const schema = this.getUpsellYupSchema();
                            formData = proccessUpsellSmileDesignDataFromServerToStore(formData);
                            const isFormValid = schema.isValidSync(formData);
                            intialState['upSellSmileDesignPrescriptionFormData'] = formData;
                            intialState['upSellSmileDesignPrescriptionFormIsValid'] = isFormValid;
                        }
                    }
                }

                //set Photo Data
                let modifiedFilesData = [...this.props.NewPatientData.files];
                let facialScanPath = data.case[0].case_file?.[0]?.[0]?.['3D_facial_scan'];
                facialScanPath = facialScanPath
                    ? /^https?:\/\//.test(facialScanPath) ? facialScanPath : join(ApiServerUrl, facialScanPath)
                    : null;
                intialState['facialScan'] = {
                    data: facialScanPath,
                    dataURL: facialScanPath,
                    name: facialScanPath ? facialScanPath.split('?')[0].split('/').pop() : '',
                };
                let radioKey = 0,
                    stlKey = 0,
                    key = '';
                modifiedFilesData.forEach((v, index) => {
                    if (v.category === 'photo' || v.category === 'radio') {
                        key = v.category === 'radio' ? v.category + radioKey : v.category + index;
                        radioKey = v.category === 'radio' ? radioKey + 1 : 0;
                        let filePath = data.case[0].case_file.length > 0 && data.case?.[0]?.case_file?.[0]?.[0]?.[key];

                        v['data'] = filePath
                            ? /^https?:\/\//.test(filePath) || /^dbx::/.test(filePath)
                                ? filePath
                                : join(ApiServerUrl, filePath)
                            : '';
                        v['dataURL'] = filePath ? v['data'] : null;
                        v['uploaded'] = filePath;
                        v['upload_later'] = data.case[0].case_file?.[0]?.[0]?.[`${key}_later`] === true;
                        v['will_not_upload'] = data.case[0].case_file?.[0]?.[0]?.[`${key}_later`] === null;
                    } else {
                        key = v.category + stlKey;
                        stlKey = stlKey + 1;
                        let filePath =
                            data.case[0].case_impression.length > 0 && data.case?.[0]?.case_impression?.[0]?.[0]?.[key];
                        v['data'] = filePath
                            ? /^https?:\/\//.test(data.case?.[0]?.case_impression?.[0]?.[0]?.[key])
                                ? filePath
                                : join(ApiServerUrl, filePath)
                            : '';
                        v['dataURL'] = filePath ? v['data'] : null;
                        v['uploaded'] = filePath;
                        v['upload_later'] = data.case[0].case_impression?.[0]?.[0]?.stl_files_later === true;
                        v['will_not_upload'] = data.case[0].case_impression?.[0]?.[0]?.stl_files_later === null;
                    }
                });
                intialState['files'] = modifiedFilesData;
                intialState['impressionType'] =
                    (data.case[0].case_impression.length > 0 && data.case?.[0]?.case_impression?.[0]?.[0]?.type) ??
                    'FILE';
                intialState['scannerBrand'] =
                    data.case[0].case_impression.length > 0 &&
                    data.case?.[0]?.case_impression?.[0]?.[0]?.['scanner_brand']
                        ? data.case?.[0]?.case_impression?.[0]?.[0]?.['scanner_brand']
                        : '';
                intialState['doctorId'] =
                    data.case[0].case_impression.length > 0 && data.case?.[0]?.case_impression?.[0]?.[0]?.['doctor_id']
                        ? data.case?.[0]?.case_impression?.[0]?.[0]?.['doctor_id']
                        : '';
                intialState['modernCode'] =
                    data.case[0].case_impression.length > 0 &&
                    data.case?.[0]?.case_impression?.[0]?.[0]?.['modern_code']
                        ? data.case?.[0]?.case_impression?.[0]?.[0]?.['modern_code']
                        : '';
                intialState['waybillNumber'] =
                    data.case[0].case_impression.length > 0 &&
                    data.case?.[0]?.case_impression?.[0]?.[0]?.['waybill_number']
                        ? data.case?.[0]?.case_impression?.[0]?.[0]?.['waybill_number']
                        : '';
                intialState['courierCompany'] =
                    data.case[0].case_impression.length > 0 &&
                    data.case?.[0]?.case_impression?.[0]?.[0]?.['courier_company']
                        ? data.case?.[0]?.case_impression?.[0]?.[0]?.['courier_company']
                        : '';
                let errors = [],
                    photo_counter = 0,
                    radio_counter = 0,
                    impression_counter = 0;

                const caseType = data.case[0].case_type;

                this.props.NewPatientData.files.forEach((v) => {
                    if (
                        [
                            'jaw_side_with_smile',
                            'face_front_with_smile',
                            'teeth_side_without_smile',
                            'jaw_front_with_smile',
                            'teeth_side_with_smile',
                            'jaw_side_without_smile',
                            ...(this.props.displayFirstFitFlag ? ['big_smile_full_face_with_full_retractors'] : []),
                        ].includes(v.id) &&
                        !v.data &&
                        !v.upload_later &&
                        !v.will_not_upload
                    ) {
                        photo_counter += 1;
                    }

                    if (
                        v.category === 'radio' &&
                        v.id === 'front_with_smile' &&
                        !v.data &&
                        !v.upload_later &&
                        !v.will_not_upload
                    ) {
                        radio_counter += 1;
                    }

                    if (
                        v.category === 'stl_file' &&
                        !v.data &&
                        !(v.id === 'impression_scan_two' && (v.data === null || v.data === '')) &&
                        !v.upload_later &&
                        !v.will_not_upload
                    ) {
                        impression_counter += 1;
                    }
                });

                if (photo_counter && caseType !== 'RETAINER' && caseType !== CASE_TYPE.SELF_DESIGN) {
                    let obj = { id: 'photo', msg: this.get('warning.mandatoryPhoto'), valid: false };
                    errors.push(obj);
                }

                if (radio_counter && caseType !== 'RETAINER' && caseType !== CASE_TYPE.SELF_DESIGN) {
                    let obj = { id: 'radiograph', msg: this.get('warning.mandatoryRadiograph'), valid: false };
                    errors.push(obj);
                }

                const retainerRequestPrescriptionNote = getRetainerRequestPrescriptionNotesData(data);
                intialState['retainerRequestPrescriptionNote'] = retainerRequestPrescriptionNote;

                // only validate retainer_request_prescription if case type is 'RETAINER'
                // if case type !== 'RETAINER', retainer_request_prescription form errors will be undefined
                if (caseType === 'RETAINER') {
                    // TODO: need update error msg pushing
                    const { targetTypeRetainerValidationFunc } = this.props.diffRetainer;
                    let isRetainerRequestValid = false;
                    if (targetTypeRetainerValidationFunc) {
                        isRetainerRequestValid = targetTypeRetainerValidationFunc();
                    }
                    let msg = isRetainerRequestValid ? '' : this.get('warning.prescription_notes');
                    errors.push({ id: 'retainer_request_prescription', msg: msg, valid: isRetainerRequestValid });
                }

                if (ALIGNER_CASE_TYPE.includes(caseType)) {
                    const mergedForValidation = { ...this.props.NewPatientData, ...intialState };
                    const isShowPrescriptionErr = validateFormFieldsOnChangeForTabsReminder({
                        attachments: mergedForValidation.attachments1,
                        spacingAndCrowding: mergedForValidation.spacingAndCrowding1,
                        openbite: mergedForValidation.openbite1,
                        deepBite: mergedForValidation.deepBite1,
                        midline: mergedForValidation.midline1,
                        posteriorCrossbite: mergedForValidation.posteriorCrossbite1,
                        auxiliaries: mergedForValidation.auxiliaries1,
                        restorativeOptions: mergedForValidation.restorativeOptions,
                        preImplantAligment: mergedForValidation.preImplantAligment,
                        archToTreat: mergedForValidation.archToTreat,
                        anteriorPosteriorRelationship: mergedForValidation.anteriorPosteriorRelationship1,
                    });
                    const prescriptionErr = {
                        id: Base_Prescription_Err.id,
                        msg: isShowPrescriptionErr ? this.get('@NewPatient.warning.prescription_notes') : '',
                        valid: !isShowPrescriptionErr,
                    };
                    const isAddOnSmileDesign = intialState['addOnSmileDesign']?.value === 'Yes';
                    const isUpsellPrescriptionValid =
                        intialState['upSellSmileDesignPrescriptionFormIsValid'] === true;
                    const baseUpsellSmileDesignPrescritpionErr = isAddOnSmileDesign
                        ? buildSmileDesignPrescriptionErr(isUpsellPrescriptionValid, () =>
                              this.get('@NewPatient.warning.smile_design_prescription_notes')
                          )
                        : { ...Base_Smile_Design_Prescription_Err };
                    errors.push({ id: prescriptionErr.id, msg: prescriptionErr.msg, valid: prescriptionErr.valid });
                    errors.push({
                        id: baseUpsellSmileDesignPrescritpionErr.id,
                        msg: baseUpsellSmileDesignPrescritpionErr.msg,
                        valid: baseUpsellSmileDesignPrescritpionErr.valid,
                    });
                }

                if (caseType !== CASE_TYPE.SELF_DESIGN) {
                    const impression =
                        data.case[0].case_impression.length > 0 && data.case?.[0]?.case_impression?.[0]?.[0];
                    switch (impression?.type ?? 'FILE') {
                        case 'FILE': {
                            if (impression_counter) {
                                errors.push({ id: 'impression', msg: this.get('warning.allStl'), valid: false });
                            }
                            break;
                        }
                        case 'COURIER': {
                            if (String.isBlank(impression.modern_code)) {
                                errors.push({ id: 'impression', msg: this.get('warning.courier'), valid: false });
                            }
                            break;
                        }
                        case 'SCANNER': {
                            if (String.isBlank(impression.scanner_brand) || String.isBlank(impression.doctor_id)) {
                                errors.push({ id: 'impression', msg: this.get('warning.scanner'), valid: false });
                            }
                            break;
                        }
                        default:
                            this.props.showSnackbar('Unknown impression type', 'error');
                            throw new Error('unknown impression type');
                    }
                }
                intialState['errors'] = errors;
                intialState['ray_draft_changed'] = data.case[0].case_file?.[0]?.[0]?.ray_draft_changed
                    ? JSON.parse(data.case[0].case_file?.[0]?.[0]?.ray_draft_changed)
                    : [];
                chosenDraftFile = data.case?.[0]?.chosen_draft_file;
                this.props.setTempData(intialState);
                this.setState({ patientInfo: 'Edit Patient', NewCaseType: caseType });
            }
        } else if (this.props.caseAction !== undefined && String.isNotBlank(this.state.current_patient_id)) {
            // stop to initData();
        } else {
            this.props.initData();
            this.setState({ patientInfo: 'newPatient' });
        }

        // Purpose: Get the list of patients that can submit a smile design case
        if (smileDesignProductListArray.includes(this.state.NewCaseType)) {
            const patientCanSubmitSmileDesignCaseList =
                await this.GetPatientCanSubmitSmileDesignCaseList(currentDoctorId);
            this.setState({ doctor_patient_CanSubmitSmileDesignCaseList: patientCanSubmitSmileDesignCaseList });
        }

        // Purpose: Get the list of patients that can submit aligner case  if the patient has smile design case
        if (!smileDesignProductListArray.includes(this.state.NewCaseType)) {
            const patientCanSubmitAlignerCaseIfSmileDesignCaseList =
                await this.GetPatientCanSubmitAlignerCaseIfSmileDesignCaseList(currentDoctorId);
            this.setState({
                doctor_patient_CanSubmitAlignerCaseIfSmileDesignCaseList:
                    patientCanSubmitAlignerCaseIfSmileDesignCaseList,
            });
        }

        const patientListResult = await this.GetCurrentPatientList(currentDoctorId);
        this.setState({ doctor_patient_list: patientListResult });
        this.setState({ chosenDraftFile });
        this.props.handleInitData(this.state.countryList, this.state.stateList, this.state.addressList);
        this.props.handleInitDraftFileList(this.state.draftFileList, this.state.chosenDraftFile);
        this.props.handleDeliveryId(this.state.addressList, delivery_id);

        if (String.isNotBlank(this.props.match.params.type) && this.props.match.params.type === 'RETAINER') {
            this.props.ErrorData({ id: 'photo', msg: '', valid: true });
            this.props.ErrorData({ id: 'radiograph', msg: '', valid: true });
        }

        // retainer_request_prescription is only for case type === RETAINER
        // skip checking for other case types
        if (String.isNotBlank(this.props.match.params.type) && this.props.match.params.type !== 'RETAINER') {
            this.props.ErrorData({ id: 'retainer_request_prescription', msg: '', valid: true });
        }
        // state for Aligner case tabs, only display skeleton when componentDidMount
        // skeleton for preventing user's operation before tabs data ready
        // early set state and not waiting for below data fetching which is not related to tabs rendering
        this.setState({ isValidatedOnMount: true });

        try {
            if (auth.user?.role === ROLE_NAMES.doctor) {
                if (!this.state.threeshapeConnected) {
                    let { data } = await axios.get(`/threeshape/check_connect`);
                    if (data.success) {
                        this.setState({ threeshapeConnected: true });
                    } else {
                        this.setState({ threeshapeConnected: false });
                    }
                }
                this.props.fetchScannerPlatform();
            }
        } catch (error) {
            this.setState({ threeshapeConnected: false });
        }

        try {
            if (this.state.NewCaseType && this.state.role === 'DR') {
                const {
                    data: { pm },
                } = await axios.get(`/productmatrix/productmatrixForDr`);
                const result = await axios.get(
                    `/productmatrix/productmatrixForDr/${isMarieGroup ? 'EU_UNDER_MARIE' : 'SMILE_DESIGN'}`
                ); // Purpose: get product matrix for smile design
                const fetchUserTestData = this.props.userAllowedFeatures.allowedFeatures; // get from redux store instead of api call
                let allPm = [...pm, ...result.data.pm];
                this.setState({ pm: allPm });

                const pmList = allPm.map((type) => type.case_type);

                if (
                    !fetchUserTestData?.['smile_design'] &&
                    smileDesignProductListArray.includes(this.state.NewCaseType)
                ) {
                    // Purpose: guard user link access to create smile design case
                    this.setState({ checkCaseTypeAuth: false });
                    this.props.showSnackbar('You are not allowed to create this case', 'error');
                    this.props.history.push('/');
                }

                this.props.checkReleaseSmileDesignByDstriAndAllowUserTest({
                    productMatrixList: result.data.pm,
                    featureList: fetchUserTestData,
                });

                // Debug
                // console.log("pmList: ",pmList);
                // console.log("smileDesignProductList: ", smileDesignProductList);
                // console.log("this.state.NewCaseType: ", this.state.NewCaseType);
                // console.log('here: ', [smileDesignProductList.simple.type].includes(this.state.NewCaseType));

                if (
                    !pmList.includes(this.state.NewCaseType) ||
                    [smileDesignProductList.simple.type].includes(this.state.NewCaseType)
                ) {
                    this.setState({ checkCaseTypeAuth: false });

                    this.props.showSnackbar('Your case type is invalid', 'error');
                    this.props.history.push('/');
                }
            }
            if (this.state.NewCaseOption) {
                const { data: result } = await axios.get(
                    `/case/checkcaseoption/${this.state.doctor_dist_id}/${this.state.NewCaseOption}`
                );
                if (!result.success) {
                    this.setState({ checkCaseOptionAuth: false });
                    this.props.showSnackbar('Your new case option is invalid', 'error');
                    this.props.history.push('/');
                }
            }
        } catch (err) {
            console.error('err', err);
            this.props.history.push('/');
        }
        this.addTraceLogToState('componentDidMount End');
        this.checkCaseType('componentDidMount');
        if (this.state.tabMode) {
            this.props.setVisitedTabs(this.state.tabMode);
        }
    }

    isRenderUpsellSmileDesignForm() {
        const { addOnSmileDesign } = this.props.NewPatientData;
        // TODO add backend flag to determine display updell SD form or not
        const addOnSmileDesignValue = addOnSmileDesign?.value === 'Yes';
        return addOnSmileDesignValue && this.state.tabMode === WORKFLOW_TAB.PRESCRIPTION_NOTES_UPSELL_SMILE_DESIGN;
    }

    /**
     * Returns the Upsell Smile Design validation schema.
     */
    getUpsellYupSchema() {
        return createStaticSmileDesignQuestionSchema({
            isMarieGroup: this.state.isMarieGroup,
            isSEAGroup: this.state.isSEAGroup,
            isUpSellTab: true,
            displayFirstFitFlag: this.props.displayFirstFitFlag,
        });
    }

    showDraftWarning() {
        if (this.state.isExcludeDraftWarning) return false;
        return this.state.isDraft;
    }

    /**
     * Renders the New Patient case form.
     */
    render() {
        const { classes } = this.props;
        const { firstName, lastName, files } = this.props.NewPatientData;
        return (
            <Animated animationIn="fadeIn" isVisible={true} style={{ backgroundColor: 'rgb(242, 242, 242)' }}>
                <PercentageProgressRing ref={this.progressBarRef} open={this.state.uploading} />
                {this.showDraftWarning() && (
                    <Prompt
                        when={!this.state.saved && this.state.checkCaseOptionAuth && this.state.checkCaseTypeAuth}
                        message={(location, action) => {
                            return `${this.get('warning.leaveWithoutSave')} \n${this.get('warning.saveDraft')}`;
                        }}
                    />
                )}

                {this.state.showAlert && (
                    <>
                        <AlertDialog
                            title="Warning"
                            dialogOpen={true}
                            handleDialogClose={() => this.handleAlertClose()}
                            content={this.state.alertMessage}
                        />
                    </>
                )}
                <Fragment>
                    {this.state.patientInfo == null || this.props.isLoading ? (
                        <Loader />
                    ) : (
                        <Grid container className={classes.devicesContainer}>
                            <Grid item xs={12} className={classes.leftCards}>
                                <Grid container className={classes.mainContainer}>
                                    <Button
                                        variant="contained"
                                        className={this.props.classes.back}
                                        onClick={() => {
                                            if (
                                                this.props.lastTimeOpenCaseId !== null &&
                                                this.props.lastTimeOpenCaseId !== undefined
                                            ) {
                                                const backtoCaseId = this.props.lastTimeOpenCaseId;
                                                this.props.history.push(`/patients/${backtoCaseId}`);
                                            } else {
                                                this.props.history.push('/');
                                            }
                                        }}
                                    >
                                        {getFromObj(this.props.lang, 'dict.pages.newpatient.back')}
                                    </Button>
                                    <NewPatientsTabs
                                        isTabsReady={this.isTabsReady()}
                                        tabMode={this.state.tabMode}
                                        handleChangeTab={(tab) => this.handleChangeTab(tab)}
                                        handleValidation={(err) => {
                                            this.handleValidation(err);
                                        }}
                                        firstName={firstName}
                                        lastName={lastName}
                                        files={files}
                                        NewPatientAddressData={this.props.NewPatientAddressData}
                                        NewCaseType={this.state.NewCaseType}
                                        tabs={this.state.tabs}
                                    />

                                    <Grid item xs={12}>
                                        <div ref={formStartRef} />
                                        <h3
                                            style={{
                                                textAlign: 'left',
                                                fontWeight: 600,
                                                color: '#2eafb6',
                                                fontSize: 24,
                                                marginBlockStart: 0,
                                                marginBlockEnd: 0,
                                            }}
                                        >
                                            {this.get('breadcrumbs.newCase')} - {this.get(`tabs.${this.state.tabMode}`)}
                                        </h3>
                                        {SELF_DESIGN_CASE_TYPE.includes(this.state.NewCaseType) && (
                                            <h4 style={{ marginTop: 10, color: '#2eafb6', fontWeight: 600 }}>
                                                {this.get('breadcrumbs.selfDesignReminder')}
                                            </h4>
                                        )}
                                        {this.state.tabMode === 'prescriptionNotes' ||
                                        this.state.tabMode === 'summary' ? (
                                            <>
                                                <h3
                                                    style={{
                                                        textAlign: 'left',
                                                        fontWeight: 600,
                                                        color: '#2eafb6',
                                                        fontSize: 24,
                                                        marginBlockStart: 0,
                                                        marginBlockEnd: 0,
                                                    }}
                                                >
                                                    {this.get('breadcrumbs.treatmentOptionSelected')} :{' '}
                                                    {this.state.NewCaseType === 'touchUp'
                                                        ? this.get(`:caseType.TOUCH_UP`)
                                                        : this.get(`:caseType.${this.state.NewCaseType}`)}
                                                </h3>
                                                {this.state.tabMode === 'prescriptionNotes' && (
                                                    <div
                                                        style={{
                                                            marginTop: 10,
                                                            fontSize: 15,
                                                        }}
                                                    >
                                                        {this.get('breadcrumbs.reminder')}
                                                    </div>
                                                )}
                                            </>
                                        ) : null}
                                        <hr
                                            style={{ border: 'solid 3px black', width: 88, margin: '16px 0px' }}
                                            align="left"
                                        />
                                    </Grid>

                                    <div
                                        style={{
                                            display: this.state.tabMode === 'info' ? 'contents' : 'none',
                                        }}
                                    >
                                        <NewPatientInfo
                                            error={this.state.error}
                                            pm={this.state.pm}
                                            isdisabled={this.isShowTreatmentOption()}
                                            disabledNewPatientInfoInputObj={this.disabledNewPatientInfoInputObj()}
                                            // when the role is DR and case is new, it can't be edited, after the case is Draft, it can be edited the Treatment option
                                            editNewCase={this.isShowTreatmentOption() && true}
                                            role={this.state.role}
                                            case_id={this.props.match.params.id}
                                            doctor_patient_list={this.state.doctor_patient_list}
                                            doctor_patient_CanSubmitSmileDesignCaseList={
                                                this.state.doctor_patient_CanSubmitSmileDesignCaseList
                                            }
                                            doctor_patient_CanSubmitAlignerCaseIfSmileDesignCaseList={
                                                this.state.doctor_patient_CanSubmitAlignerCaseIfSmileDesignCaseList
                                            }
                                            current_patient_id={this.state.current_patient_id}
                                            isSamePatientCreateNewCaseAction={this.isSamePatientCreateNewCaseAction()}
                                            UpdateNewCaseForExistPatientFunc={(patient_id) => {
                                                this.setState({ current_patient_id: patient_id });
                                            }}
                                            isStartedCaseEditPatientInfo={false}
                                            defaultTabOpen={this.state.current_patient_id != null ? 1 : 0}
                                            newCaseType={this.state.NewCaseType}
                                        />
                                    </div>

                                    <div
                                        style={{
                                            display: this.state.tabMode === 'prescriptionNotes' ? 'block' : 'none',
                                            width: '100%',
                                        }}
                                    >
                                        {smileDesignProductListArray.includes(this.state.NewCaseType) ? (
                                            <SmileDesignPrescriptionNotes
                                                key={'SMILE_DESIGN'}
                                                schema={createStaticSmileDesignQuestionSchema({
                                                    isMarieGroup: this.state.isMarieGroup,
                                                    isSEAGroup: this.state.isSEAGroup,
                                                    isUpSellTab: false,
                                                    displayFirstFitFlag: this.props.displayFirstFitFlag,
                                                })}
                                                isUpSellTab={false}
                                                isMarieGroup={this.state.isMarieGroup}
                                                isTWGroup={this.state.isTWGroup}
                                                isSEAGroup={this.state.isSEAGroup}
                                            />
                                        ) : (
                                            <NewPatientPrescriptionNotes />
                                        )}
                                    </div>

                                    {this.isRenderUpsellSmileDesignForm() && (
                                        <div style={{ width: '100%' }}>
                                            <UpSellSmileDesignPrescriptionNotes
                                                isMarieGroup={this.state.isMarieGroup}
                                                isTWGroup={this.state.isTWGroup}
                                                isSEAGroup={this.state.isSEAGroup}
                                                schema={this.getUpsellYupSchema()}
                                            />
                                        </div>
                                    )}

                                    <div
                                        style={{
                                            display:
                                                this.state.tabMode === 'retainer_request_prescriptionNotes'
                                                    ? 'block'
                                                    : 'none',
                                            width: '100%',
                                        }}
                                    >
                                        <DiffRetainerTab
                                            handleSaveDraft={this.handleSave}
                                            caseId={this.props.match.params.id}
                                            tabMode={this.state.tabMode}
                                        />
                                    </div>

                                    <div
                                        style={{
                                            display: this.state.tabMode === 'delivery' ? 'contents' : 'none',
                                        }}
                                    >
                                        <NewPatientDelivery tabMode={this.state.tabMode} />
                                    </div>

                                    <div
                                        style={{
                                            display: this.state.tabMode === 'photos' ? 'contents' : 'none',
                                        }}
                                    >
                                        <NewPatientPhotos
                                            tabMode={this.state.tabMode}
                                            rayFiles={this.state.rayFiles}
                                            handleValidation={(err) => {
                                                this.handleValidation(err);
                                            }}
                                        />
                                    </div>

                                    <div
                                        style={{
                                            display: this.state.tabMode === 'impression' ? 'contents' : 'none',
                                        }}
                                    >
                                        <NewPatientPhotos
                                            tabMode={this.state.tabMode}
                                            threeshapeConnected={this.state.threeshapeConnected}
                                            handleThreeshapeConnected={(value) =>
                                                this.setState({ threeshapeConnected: value })
                                            }
                                        />
                                    </div>

                                    <div
                                        style={{
                                            display: this.state.tabMode === 'radiography' ? 'contents' : 'none',
                                        }}
                                    >
                                        <NewPatientPhotos
                                            tabMode={this.state.tabMode}
                                            case_type={this.state.NewCaseType}
                                        />
                                    </div>

                                    <div
                                        style={{
                                            display: this.state.tabMode === 'summary' ? 'contents' : 'none',
                                        }}
                                    >
                                        <NewPatientSummary
                                            NewCaseType={this.state.NewCaseType}
                                            isMarieGroup={this.state.isMarieGroup}
                                            isSEAGroup={this.state.isSEAGroup}
                                        />
                                    </div>
                                </Grid>
                            </Grid>

                            <Grid item xs={12}>
                                <NewPatientsButtonTabs
                                    isTabsReady={this.isTabsReady()}
                                    savingData={this.state.savingData}
                                    handleSave={(saveType) => this.handleSave(saveType)}
                                    tabMode={this.state.tabMode}
                                    handleChangeTab={(tab) => this.handleChangeTab(tab)}
                                    displayFirstFitFlag={this.props.displayFirstFitFlag}
                                    handleValidation={(err) => {
                                        this.handleValidation(err);
                                    }}
                                    firstName={firstName}
                                    lastName={lastName}
                                    files={files}
                                    NewPatientAddressData={this.props.NewPatientAddressData}
                                    NewCaseType={this.state.NewCaseType}
                                    tabs={this.state.tabs.map((t) => t?.tab)}
                                />
                            </Grid>
                        </Grid>
                    )}
                </Fragment>
            </Animated>
        );
    }
}

/**
 * Maps Redux state to New Patient props.
 */
const mapStateToProps = (store) => {
    return {
        NewPatientData: store.newPatientReducer,
        NewPatientAddressData: store.newAddressReducer,
        isLoading: store.loading.isLoading,
        lang: store.lang,
        config: store.config.config,
        smileDesign: store.smileDesign,
        diffRetainer: store.diffRetainer,
        lastTimeOpenCaseId: store.newCaseReducer.lastTimeOpenCaseId,
        auth: store.auth,
        userAllowedFeatures: store.userAllowedFeatures,
        displayFirstFitFlag: store.globalReducer.displayFirstFitFlag,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveData: (newPatientData) => dispatch(saveAction.save(newPatientData)),
        setTempData: (newPatientData) => dispatch(saveAction.tempSave(newPatientData)),
        initData: () => dispatch({ type: 'NEW_PATIENT_INIT_TEMP' }),
        handleInitData: (countryList, stateList, addressList) =>
            dispatch({
                type: 'NEW_PATIENT_DELIVERY_ADDRESS_INIT',
                country: countryList,
                state: stateList,
                address: addressList,
            }),
        handleDeliveryId: (address, delivery_id) =>
            dispatch({ type: 'NEW_PATIENT_DELIVERY_ADDRESS', address, delivery_id }),
        saveAddressId: (addressId) => dispatch({ type: 'NEW_PATIENT_DELIVERY_ADDRESS_ID', value: addressId }),
        handleInitDraftFileList: (draftFileList, chosenDraftFile) =>
            dispatch({ type: 'NEW_PATIENT_INIT_DRAFT_FILE', draftFileList, chosenDraftFile }),
        showSnackbar: (msg, variant, queue = false) => dispatch(easySnackbar(msg.toString(), variant, queue)),
        ErrorData: (errorMsg) => dispatch({ type: 'NEW_PATIENT_DATA_ERROR', errorMsg: errorMsg }),
        traceLog: (logData) => dispatch(postTraceLog(logData)),
        clearUpdateLastOpenCaseIdFunc: () => dispatch(updateLastOpenCaseId(null)),
        saveRetainerRequestPrescriptionNote: (data) =>
            dispatch({ type: 'NEW_PATIENT_SET_RETAINER_REQUEST', payload: data }),
        checkReleaseSmileDesignByDstriAndAllowUserTest: ({ productMatrixList, featureList }) =>
            dispatch(checkReleaseSmileDesignByDstriAndAllowUserTest({ productMatrixList, featureList })),
        openRedirectUserModal: (value) =>
            dispatch(
                openModal({
                    modalTitle: value.title,
                    modalMessage: value.message,
                    modalCallbackFunc: value.modalCallbackFunc,
                    modalOnCloseCallbackFunc: value.modalOnCloseCallbackFunc,
                    showOk: value.showOk,
                })
            ),
        fetchScannerPlatform: () => dispatch(fetchConnectPlatformData()),
        setVisitedTabs: (tab) => dispatch({ type: 'NEW_PATIENT_SET_VISITED_TABS', value: tab }),
        showGuidedVeneerScanGuidance: () =>
            dispatch(
                setDialog({
                    title: '@NewPatient.warning.guidedVeneerUploadScanGuidanceTitle',
                    content: '@NewPatient.warning.guidedVeneerUploadScanGuidanceContent',
                })
            ),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(withRouter(withLang(NewPatient, 'NewPatient'))));
